import { theme as antdTheme } from 'antd'
import { THEME_CONFIG, type ThemeColor, type ThemeMode } from './design-tokens'
const { defaultAlgorithm, darkAlgorithm } = antdTheme

const themeConfigAntd = (
  theme: ThemeMode,
  themeColor: ThemeColor = 'primary',
  antdThemeConfig?: object
): any => {
  const tokens = THEME_CONFIG[themeColor]

  const config = {
    algorithm: theme === 'dark' ? darkAlgorithm : defaultAlgorithm,
    token: {
      colorInfo: tokens.colorInfo,
      colorPrimary: tokens.colorPrimary,
      fontSize: 14,
      fontFamily: `"Inter", sans-serif, ui-sans-serif, "Segoe UI Emoji", "Noto Color Emoji", Helvetica, sans-serif`,
      lineHeight: 1.5,
      borderRadius: 8,
    },
    components: {
      ...tokens.components,
    },
  }

  if (!antdThemeConfig) return config

  return {
    ...config,
    ...antdThemeConfig,
  }
}

export default themeConfigAntd
